import { LinearProgress, Paper } from "@mui/material";
import { Col } from "components/atoms/col";
import { Row } from "components/atoms/row";
import { Text } from "components/atoms/text";
import { User } from "core/types/user.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  user: User;
}

const UserStats: FunctionComponent<Props> = ({ user }) => {
  const { t } = useTranslation();

  const checkStatus = (value: number, base: number) => {
    const basedValue = base === 100 ? value : Math.round((value / base) * 100);
    if (basedValue < 33) {
      return "error";
    } else if (basedValue >= 33 && basedValue <= 67) {
      return "warning";
    } else if (basedValue > 67) {
      return "success";
    }
  };

  return (
    <Paper
      sx={{
        width: "100%",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      {user?.billingInfo && (
        <>
          <Text variant="h4" fontWeight={"600"} mb={"8px"}>
            {t("profile.billing-title")}
          </Text>
          {/* <Row
            container
            style={{
              marginBottom: "8px",
              paddingBottom: "8px",
              borderBottom: "0.5px solid #979EB0",
            }}
          >
            <Col item xs={12} md={6}>
              <Text fontSize={"13px"} fontWeight={"500"}>
                {t("profile.level")}
              </Text>
            </Col>
            <Col
              item
              xs={12}
              md={6}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"row"}
            >
              <Text ml={"2px"}>{user?.billingInfo?.level}</Text>
            </Col>
          </Row> */}

          <Row
            container
            style={{
              marginBottom: "8px",
              paddingBottom: "8px",
              borderBottom: "0.5px solid #979EB0",
            }}
          >
            <Col item xs={12} md={6}>
              <Text fontSize={"13px"} fontWeight={"500"}>
                {t("profile.available-searches")}
              </Text>
            </Col>
            <Col
              item
              xs={12}
              md={6}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"row"}
            >
              <LinearProgress
                value={user?.billingInfo?.searchesCount}
                variant="determinate"
                color={
                  user?.billingInfo
                    ? checkStatus(user?.billingInfo?.searchesCount, 100)
                    : "error"
                }
                sx={{ width: "100%" }}
              />
              <Text ml={"2px"}>{user?.billingInfo?.searchesCount}</Text>
            </Col>
          </Row>

          <Row
            container
            style={{
              marginBottom: "8px",
              paddingBottom: "8px",
              borderBottom: "0.5px solid #979EB0",
            }}
          >
            <Col item xs={12} md={6}>
              <Text fontSize={"13px"} fontWeight={"500"}>
                {t("profile.remaining-reports")}
              </Text>
            </Col>
            <Col
              item
              xs={12}
              md={6}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"row"}
            >
              <LinearProgress
                value={user?.billingInfo?.reportCount}
                variant="determinate"
                color={
                  user?.billingInfo
                    ? checkStatus(user?.billingInfo?.reportCount, 100)
                    : "error"
                }
                sx={{ width: "100%" }}
              />
              <Text ml={"2px"}>{user?.billingInfo?.reportCount}</Text>
            </Col>
          </Row>

          <Row container>
            <Col item xs={12} md={6}>
              <Text fontSize={"13px"} fontWeight={"500"}>
                {t("profile.remaining-tokens")}
              </Text>
            </Col>
            <Col
              item
              xs={12}
              md={6}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"row"}
            >
              <LinearProgress
                value={
                  user?.billingInfo
                    ? Math.round(user?.billingInfo?.tokensCount / 10000)
                    : 0
                }
                variant="determinate"
                color={
                  user?.billingInfo
                    ? checkStatus(user?.billingInfo?.tokensCount, 1000000)
                    : "error"
                }
                sx={{ width: "100%" }}
              />
              <Text ml={"2px"}>{user?.billingInfo?.tokensCount}</Text>
            </Col>
          </Row>
        </>
      )}
    </Paper>
  );
};

export default UserStats;
